import { ActionIcon, Tooltip } from '@mantine/core'
import { IconVolume, IconPlayerStopFilled } from '@tabler/icons-react'
import { useSpeech } from '../../hooks/useSpeech'

/**
 * Per-segment play/stop control. Always available (manual playback works even
 * with auto-play off); renders nothing only when there's no segment to play.
 * `segment` is the descriptor consumed by useSpeech (see that hook).
 */
export function SpeakButton({ segment, size = 'sm' }) {
  const { playingId, toggleSegment } = useSpeech()
  if (!segment) return null

  // A beat's index-0 button plays the whole beat, so treat ANY of that beat's
  // segments (beat:<id>:N) playing as "this is playing" — otherwise the button
  // would lose its stop state once a later voice segment starts.
  const isBeatRoot = segment.kind === 'beat' && (segment.segmentIndex ?? 0) === 0
  const isPlaying = isBeatRoot && playingId
    ? playingId.startsWith(`beat:${segment.beatId}:`)
    : playingId === segment.id

  return (
    <Tooltip label={isPlaying ? 'Stop' : 'Play aloud'} withArrow>
      <ActionIcon
        size={size}
        variant="subtle"
        color={isPlaying ? 'red' : 'gray'}
        aria-label={isPlaying ? 'Stop speech' : 'Play this aloud'}
        onClick={(e) => { e.stopPropagation(); toggleSegment(segment) }}
      >
        {isPlaying ? <IconPlayerStopFilled size={16} /> : <IconVolume size={16} />}
      </ActionIcon>
    </Tooltip>
  )
}
